
import React from 'react'
import { ScrollView, StyleSheet, View } from 'react-native'

import ConfettiCelebration from '@/components/Mini/ConfettiCelebration'

import * as cth from '@/router/(root)/cth/cthModule'
import { CthBackground as Background } from "@/components/Mini/Background"
import { CthHeader as Header } from "@/components/Mini/Header"
import { CthStatsCard as StatsCard} from "@/components/Mini/StatsCard"
import { CthStreakStats as StreakStats} from "@/components/Mini/StreakStats"
import { CthLeaderboardCard as LeaderboardCard} from "@/components/Mini/LeaderboardCard"
import { PrimaryBtn, SecondaryBtn } from "@/components/Mini/Button"
import { CthDiamondsCard as DiamondsCard } from "@/components/Mini/DiamondsCard"

import type { MinigameModule } from '@/types/minigameModule'

function CthResultsScreen(){

  const m = cth

  const isPerfect = m.useIsPerfect()
  const playedDate = m.useStore((s) => s.playedDate)

  const { isAdmin, isSuperAdmin } = m.useCthUser()

  return (
    <>
    {isPerfect && <ConfettiCelebration />}
    <Background>
          <ResultsScreenHeader m={m}/>
          <ScrollView contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
            <StatsCard />
            {(isAdmin || isSuperAdmin) && <DiamondsCard />}
            <StreakStats />
            <LeaderboardCard compact={true} />
          </ScrollView>
          <Footer />

    </Background>
</>
  )

}

function ResultsScreenHeader({ m }: { m: MinigameModule }) {

  const handleHome = m.useHandleHome()

  return (
    <Header title="Your Results" handler={handleHome} />
  )
}

function Footer(){

  return (
    <View style={styles.footer}>
      <ShareBtn />
    </View>
  )
  
}

function ShareBtn(){

  const handleShare = cth.useHandleShare()

  const theme = cth.useStore(s => s.theme)

  return (
    <PrimaryBtn theme={theme} handler={handleShare} label="Share your results" />
  )
}


const styles = StyleSheet.create({
  fill: { flex: 1 },
  scrollContent: { paddingHorizontal: 16, paddingBottom: 16,  gap: 16 },
  footer: { paddingHorizontal: 24, paddingBottom: 16, paddingTop: 8, gap: 12 }
})

export { CthResultsScreen }
